import { render } from "./site-search-providers.vue?vue&type=template&id=20f461ff"
import script from "./site-search-providers.vue?vue&type=script&lang=js"
export * from "./site-search-providers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__